export const DIARY_STUDENT_MENU = "diary_student_menu";
export const DIARY_CLASSES_MENU = "diary_classes_menu";
export const MENU_TITLE_STATE_KEY = "__menuTitle";

function replacePlaceholders(route, ids) {
  return String(route || "")
    .replace(/:studentId/g, ids.studentId == null ? "" : String(ids.studentId))
    .replace(/:classId/g, ids.classId == null ? "" : String(ids.classId));
}

function menuParams(menu) {
  const params = menu && menu.settings && menu.settings.params;
  if (!params || typeof params !== "object" || Array.isArray(params)) {
    return {};
  }
  return params;
}

export function buildMenuTarget(menu, ids = {}) {
  const rawRoute = replacePlaceholders(menu && menu.route, ids);
  const queryIndex = rawRoute.indexOf("?");
  const pathname = queryIndex === -1 ? rawRoute : rawRoute.slice(0, queryIndex);
  const search = new URLSearchParams(
    queryIndex === -1 ? "" : rawRoute.slice(queryIndex + 1)
  );
  const state = {};
  const title = menu && typeof menu.title === "string" ? menu.title.trim() : "";
  if (title) state[MENU_TITLE_STATE_KEY] = title;

  Object.keys(menuParams(menu)).forEach(key => {
    const spec = menuParams(menu)[key];
    if (!spec || typeof spec !== "object" || spec.value == null) return;
    if (spec.hidden === true) {
      state[key] = spec.value;
      return;
    }
    search.set(key, String(spec.value));
  });

  const query = search.toString();
  return {
    pathname,
    search: query ? `?${query}` : "",
    state
  };
}

export function menuTitleFromLocation(location) {
  const state = location && location.state;
  if (!state || typeof state !== "object" || Array.isArray(state)) return "";
  const title = state[MENU_TITLE_STATE_KEY];
  return typeof title === "string" ? title.trim() : "";
}
